exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".overview-card[data-v-4376a4aa]{cursor:pointer;transition:transform .2s,box-shadow .2s;border:none;border-radius:10px}.overview-card[data-v-4376a4aa]:hover{transform:translateY(-3px);box-shadow:0 6px 25px rgba(0,0,0,.15)}.overview-icon[data-v-4376a4aa]{opacity:.8}.card[data-v-4376a4aa]{border-radius:10px;box-shadow:0 2px 10px rgba(0,0,0,.1)}", ""]);

// exports
